module.exports = __webpack_public_path__ + "img/path-ac.3234d5c0.png";